import { FormattedMessage } from "react-intl";
import { TForecast, TWeatherForecast } from "./types";
import { useGetLanguage } from "../../../hooks/useGetLanguage";
import { ParagraphXSmall } from "baseui/typography";
import { ValueDisplay } from "../../components/ValueDisplay";
import { getDimension } from "./utils";
import { styled, withStyle } from "baseui";
import { themedUseStyletron } from "../../../theme/customTheme";

const Forecast: React.FC<TWeatherForecast & { small?: boolean }> = (props) => {
    const [css, theme] = themedUseStyletron();
    const { locale } = useGetLanguage();
    const forecast: TForecast = JSON.parse(props.forecast)
    const dim = getDimension(props.units);

    const numItems = props.small ? 6 : 24
    return (
        <MainContainer>
            <ItemsContainer>
                <NowContainer>
                    <ParagraphXSmall className={css({ whiteSpace: 'nowrap' })} ><FormattedMessage id="now" defaultMessage={'Now'}></FormattedMessage></ParagraphXSmall>
                    { forecast.current.iconUrl && <div className={css({ width: theme.sizing.scale1000, height: theme.sizing.scale1000, borderRadius: '50%', background: 'white' })}>
                        <img src={`https://openweathermap.org/img/wn/${forecast.current.iconUrl}@2x.png`} className={css({ width: '100%' })} />
                    </div>}
                    <ValueDisplay small value={props.temp} dimension={dim}></ValueDisplay>
                </NowContainer>
                {forecast?.hourly?.slice(1, numItems).map(e => {
                    return (<>
                        <ItemContainer>
                            <ParagraphXSmall className={css({ whiteSpace: 'nowrap' })}>{new Date(e.dt * 1000).toLocaleTimeString(locale, { hour: 'numeric' })}</ParagraphXSmall>
                            {e.iconUrl && <div className={css({ width: theme.sizing.scale1000, height: theme.sizing.scale1000, borderRadius: '50%', background: 'white' })}>
                                <img src={`https://openweathermap.org/img/wn/${e.iconUrl}@2x.png`} className={css({ width: '100%' })} />
                            </div>}
                            <ValueDisplay small value={e.temp} dimension={dim}></ValueDisplay>
                        </ItemContainer></>)
                })}
            </ItemsContainer>
        </MainContainer>);
};

export default Forecast;
const MainContainer = styled('div', ({ $theme }) => ({
    maxWidth: '100%',
}));

const ItemsContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    columnGap: $theme.sizing.scale300,
    flexDirection: 'row',
    overflow: 'auto',
    width: '100%',
}));

const ItemContainer = styled('div', ({ $theme }) => ({
    background: $theme.colors.tagAccentLightBackground,
    borderRadius: $theme.sizing.scale200,
    padding: $theme.sizing.scale200,
    rowGap: $theme.sizing.scale400,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
}));

const NowContainer = withStyle(ItemContainer, ({ $theme }) => ({
    background: $theme.colors.tagAccentLightActive,
}));